import React, { useState, useContext, useEffect } from "react";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useGroupScreen } from "./hooks/useGroupScreen";
import FInputt from "../../components/FInputt/FInputt";
import { useFormat } from "../../hooks/useFormat";
import { useGroup } from "../../hooks/useGroups";
import { AuthContext } from "../../context/AuthContext";
import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";

import { PencilOutline, TrashOutline } from "react-ionicons";
import Swal from "sweetalert2";

const GroupScreen = ({ param }) => {
  const { getBase64 } = useFormat();

  const {
    arrayGroups,
    setArrayGroups,
    onClickGroups,
    add,
    setAdd,
    edit,
    setEdit,
    formikAdd,
    formikEdit,
    srcFileZone,
    setSrcFileZone,
    route,
  } = useGroupScreen();

  const { loading, checkToken } = useContext(AuthContext);
  const { groups, loadGroups, setGroups } = useGroup();
  const [isRefreshing, setIsRefreshing] = useState(false);
  //const isFocused = useIsFocused();
  const { getMembers, members, deleteMember, deleteGroup, setMembers } =
    useGroup();

  async function _deleteGroupByGroupId(id) {
    checkToken()
    let _return = false;
    try {
      const dataDeleteGroupByGroupId = await deleteGroup(id);
      if (dataDeleteGroupByGroupId == true) {
        setArrayGroups(arrayGroups.filter((item) => item.id != id));
      } else {
        Swal.fire({
          showCloseButton: true,
          title: "No se encontro el grupo",
          text: "",
          imageUrl: require("../../components/assets/images/advertir.png"),
          imageWidth: 150,
          imageHeight: 150,
          confirmButtonColor: "#fd6e0d",
        });
      }
    } catch (error) {
      console.log(error);
    }
    return _return;
  }

  const _deleteGroup = (groupId) => {
    Swal.fire({
      showCloseButton: true,
      title: "Eliminar grupo",
      text: "¿Está seguro que desea eliminar el grupo?",
      imageUrl: require("../../components/assets/images/pregunta.png"),
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: "Custom image",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        _deleteGroupByGroupId(groupId);
      }
    });
  };

  useEffect(() => {
    loadGroups();
  }, []);

  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-12 xss:w-[450px] place-items-center">
          <div className="border-0 col-span-5 p-3">
            <img
              src={require("../../components/assets/images/people.png")}
              className="w-full xxs:w-[150px] h-auto flex-1"
            />
          </div>
          <div className="border-0 w-full  col-span-7 grid grid-rows-1 text-center sm:py-7 ">
            <div className="border-0 row-span-1 font-bold text-[5vw] smm:text-[20px] text-Secondary">
              Mis Grupos
            </div>
            <div className="border-0 row-span-1 font-regular text-[4vw] smm:text-[20px] px-3">
              <Fbutton
                value="Crear grupo"
                onClick={() => {
                  route("/AddPerson", {
                    state: {
                      members: [],
                      groupId: null,
                      type: "create",
                    },
                  });
                  if (add) {
                    setEdit(false);
                  }
                  setAdd(!add);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <FContainer>
        {arrayGroups?.length > 0
          ? arrayGroups.map((group) => (
              <div className="border-0 w-full grid grid-cols-12 shadow-Box rounded-2xl px-2 py-3 my-2 cursor-pointer">
                <div
                  className="border-0 col-span-2 grid place-items-center"
                  onClick={() => {
                    onClickGroups(group);
                  }}
                >
                  <img
                    src={group.picture}
                    className="w-[40px] xxxs:w-[50px] h-[40px] xxxs:h-[50px]"
                    alt=""
                  />
                </div>
                <div
                  className="border-0 col-span-9 grid grid-cols-1 items-center font-regular text-[13px] pl-2"
                  onClick={() => {
                    onClickGroups(group);
                  }}
                >
                  <div className="border-0 col-span-1 grid items-center font-bold">
                    {group.name}
                  </div>
                  <div className="border-0 col-span-1 grid items-start font-medium">
                    {group.description}
                  </div>
                </div>
                <div className="border-0 col-span-1 gap-1 grid grid-cols-1 place-items-center">
                  <div className="border-0 col-span-1">
                    <PencilOutline
                      height="27px"
                      width="27px"
                      onClick={() => {
                        route("/EditGroupScreen", {
                          state: {
                            id: group.id,
                            name: group.name,
                            description: group.description,
                            picture: group.picture,
                          },
                        });
                      }}
                    />
                  </div>
                  <div className="border-0 col-span-1">
                    <TrashOutline
                      height="27px"
                      width="27px"
                      color={"#E30000"}
                      onClick={() => {
                        _deleteGroup(group.id);
                      }}
                    />
                  </div>
                </div>
              </div>
            ))
          : null}
      </FContainer>
    </>
  );
};

export default GroupScreen;
